import React, { useEffect } from "react";
import { Icon, Stack, Text } from "@bookingcom/bui-react";
import { CalendarCheckIcon, MoneyIncomingIcon } from "@bookingcom/bui-assets-react/streamline";
import useFareRulesInfoController from "./useFareRulesInfo.controller";
import { UIFlightData } from "@flights/types";
import useClientMetrics from "../../../../../../../hooks/useClientMetrics";
import useRouteName from "../../../../../../../hooks/useRouteName";
import useProfiler from "../../../../../../../hooks/useProfiler";
import flights_web_condensed_extras_fd_mdot from "../../../../../../../utils/experiments/funnel/flights_web_condensed_extras_fd_mdot";

const useFareRulesInfo = (flight: UIFlightData) => {
  const { header, subheader, hasFareRules, changeable, cancellable } = useFareRulesInfoController(flight);
  const { trackClientMetric } = useClientMetrics();

  useEffect(() => {
    if (!hasFareRules) return undefined;
    trackClientMetric("fare_rules_available_on_flight_details");
  }, [hasFareRules, trackClientMetric]);

  const routeName = useRouteName();
  const { isMobile } = useProfiler();
  const condensedFDMobile =
    routeName == "flightdetails" && isMobile() && !!flights_web_condensed_extras_fd_mdot.trackWithDefaultStage();

  if (!hasFareRules) return undefined;

  return {
    header,
    subheader,
    content: (
      <Stack gap={4}>
        {changeable ? (
          <Stack.Item>
            <Stack direction="row" gap={4}>
              <Stack.Item>
                <Icon size={condensedFDMobile ? "medium" : "large"} svg={CalendarCheckIcon} />
              </Stack.Item>
              <Stack.Item grow alignSelf="center">
                <Text>{changeable.label}</Text>
              </Stack.Item>
            </Stack>
          </Stack.Item>
        ) : null}
        {cancellable ? (
          <Stack.Item>
            <Stack direction="row" gap={4}>
              <Stack.Item>
                <Icon size={condensedFDMobile ? "medium" : "large"} svg={MoneyIncomingIcon} />
              </Stack.Item>
              <Stack.Item grow alignSelf="center">
                <Text>{cancellable.label}</Text>
              </Stack.Item>
            </Stack>
          </Stack.Item>
        ) : null}
      </Stack>
    )
  };
};

export default useFareRulesInfo;
